import homework from '@/api/eschool/student-homework'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  edit_data: {},
  date_from: moment()
    .add(-7, 'Day')
    .format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  status: 1
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_STATUS_VALUE(state, value) {
    state.status = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        status: context.state.status
      },
      attrubutes
    )
    return homework.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return homework.store(data)
  },
  update(context, data) {
    return homework.update(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await homework.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  download(context, options) {
    return homework.download({
      params: options
    })
  }
}
